
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired7c6"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired7c6"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kyEFX", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ef7689007096c8a0$export$6503ec6e8aabbaf; }, function (v) { return $ef7689007096c8a0$export$6503ec6e8aabbaf = v; });
var $ef7689007096c8a0$export$6503ec6e8aabbaf;
var $ef7689007096c8a0$export$f7ad0328861e2f03;
"use strict";
var $ef7689007096c8a0$var$mapping = new Map();
function $ef7689007096c8a0$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$ef7689007096c8a0$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $ef7689007096c8a0$var$resolve(id) {
    var resolved = $ef7689007096c8a0$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$ef7689007096c8a0$export$6503ec6e8aabbaf = $ef7689007096c8a0$var$register;
$ef7689007096c8a0$export$f7ad0328861e2f03 = $ef7689007096c8a0$var$resolve;

});

parcelRegister("bUb57", function(module, exports) {

$parcel$export(module.exports, "amountProductsInCart", function () { return $8aad853c076397e7$export$ddf6858ef75d6d83; });

var $eayiT = parcelRequire("eayiT");

var $ls5ZR = parcelRequire("ls5ZR");
function $8aad853c076397e7$export$ddf6858ef75d6d83() {
    const count = (0, $eayiT.loadFromLocalStorage)((0, $ls5ZR.CART_KEY)) ?? [];
    const cartCounter = document.getElementById("cart-counter");
    cartCounter.textContent = `(${count.length})`;
}
(0, $eayiT.removeFromLocalStorage)((0, $ls5ZR.PRODUCTS_KEY));
$8aad853c076397e7$export$ddf6858ef75d6d83();

});
parcelRegister("eayiT", function(module, exports) {

$parcel$export(module.exports, "saveToLocalStorage", function () { return $a50c9bdec303feef$export$1b8cd2d0ef9a8e5d; });
$parcel$export(module.exports, "loadFromLocalStorage", function () { return $a50c9bdec303feef$export$e68c847c0bceb7d5; });
$parcel$export(module.exports, "removeFromLocalStorage", function () { return $a50c9bdec303feef$export$aa8cd6a69a90bc68; });
$parcel$export(module.exports, "saveUniqueElements", function () { return $a50c9bdec303feef$export$42c02b082960b9c8; });
const $a50c9bdec303feef$export$1b8cd2d0ef9a8e5d = (key1, value)=>{
    try {
        const serializedState = JSON.stringify(value);
        localStorage.setItem(key1, serializedState);
    } catch (error) {
        console.error("Set state error: ", error.message);
    }
};
const $a50c9bdec303feef$export$e68c847c0bceb7d5 = (key1)=>{
    try {
        const serializedState = localStorage.getItem(key1);
        return serializedState === null ? undefined : JSON.parse(serializedState);
    } catch (error) {
        console.error("Get state error: ", error.message);
    }
};
const $a50c9bdec303feef$export$aa8cd6a69a90bc68 = (key1)=>{
    try {
        localStorage.removeItem(key1);
    } catch (error) {
        console.error("Get state error: ", error.message);
    }
};
const $a50c9bdec303feef$export$1098e731e0c3987f = (keyProduct, keyCart, id)=>{
    try {
        const product = $a50c9bdec303feef$export$e68c847c0bceb7d5(key).some(({ _id: _id })=>{});
        const productsCart = $a50c9bdec303feef$export$e68c847c0bceb7d5(key) ?? [];
        const newProductsCart = productsCart.push(product);
        $a50c9bdec303feef$export$1b8cd2d0ef9a8e5d(key, newProductsCart);
    } catch (error) {
        console.error("Get state error: ", error.message);
    }
};
const $a50c9bdec303feef$export$42c02b082960b9c8 = (key1, products = [])=>{
    const productStorage = $a50c9bdec303feef$export$e68c847c0bceb7d5(key1) ?? [];
    if (productStorage.length > 0 && products.length > 0) {
        const map = new Map([
            ...products,
            ...productStorage
        ].map((item)=>[
                item._id,
                item
            ]));
        const uniqueProducts = [
            ...map.values()
        ];
        $a50c9bdec303feef$export$1b8cd2d0ef9a8e5d(key1, uniqueProducts);
    } else if (productStorage.length > 0 && products.length === 0) $a50c9bdec303feef$export$1b8cd2d0ef9a8e5d(key1, productStorage);
    else $a50c9bdec303feef$export$1b8cd2d0ef9a8e5d(key1, products);
};

});

parcelRegister("ls5ZR", function(module, exports) {

$parcel$export(module.exports, "FILTER_KEY", function () { return $f9e0dd55fd4595b8$export$5f06fa4a40338b57; });
$parcel$export(module.exports, "PRODUCTS_KEY", function () { return $f9e0dd55fd4595b8$export$b89a4a21c8d41fe2; });
$parcel$export(module.exports, "CART_KEY", function () { return $f9e0dd55fd4595b8$export$4bb576fa7161b2b0; });
$parcel$export(module.exports, "CATEGORY_KEY", function () { return $f9e0dd55fd4595b8$export$acaf2d7410b47903; });
const $f9e0dd55fd4595b8$export$5f06fa4a40338b57 = "filter";
const $f9e0dd55fd4595b8$export$b89a4a21c8d41fe2 = "products";
const $f9e0dd55fd4595b8$export$4bb576fa7161b2b0 = "cart";
const $f9e0dd55fd4595b8$export$acaf2d7410b47903 = "categories";
const $f9e0dd55fd4595b8$export$ad72b9e77edc72ee = "popular";
const $f9e0dd55fd4595b8$export$8b8f93d717b54099 = "discount";

});


parcelRegister("gyujb", function(module, exports) {

$parcel$export(module.exports, "createCartMarkup", function () { return $c0d754f4426227cd$export$af42f604a5c132a9; });
$parcel$export(module.exports, "createCardsMarkup", function () { return $c0d754f4426227cd$export$cdd53e9d83833acd; });
$parcel$export(module.exports, "createModalMarkup", function () { return $c0d754f4426227cd$export$fc0ff788b21a7621; });
$parcel$export(module.exports, "createPopularProductsMarkup", function () { return $c0d754f4426227cd$export$d78ba3996ccc9aa; });
$parcel$export(module.exports, "createDiscountProductsMarkup", function () { return $c0d754f4426227cd$export$b8a7adf6f62d18f9; });

var $eayiT = parcelRequire("eayiT");

var $ls5ZR = parcelRequire("ls5ZR");

var $bGAvv = parcelRequire("bGAvv");

var $dZlgb = parcelRequire("dZlgb");

var $6RuPt = parcelRequire("6RuPt");
function $c0d754f4426227cd$export$af42f604a5c132a9(products) {
    if (products.length !== 0) return products.map(({ img: img, name: name, category: category, size: size, price: price, _id: _id })=>{
        return `
            <li class="products-item" id="${_id}">
            <div class="cart-product-img-container">
              <img
                src="${img}"
                alt="${name}"
              />
            </div>
            <div class="product-info">
            <div class="cart-product-name-container">
              <h3 class="cart-product-name">${name}</h3>
              <button type="button" id="${_id}" aria-label="delete-item" data-id="${_id}" class="cart-delete-btn">
              <svg class="icon-delete-product">
                <use href="${0, (/*@__PURE__*/$parcel$interopDefault($bGAvv))}#icon-close"></use>
              </svg>
            </button>
            </div>
              <ul class="product-info-list">
                <li class="product-info-item">
                  <p class="cart-category-text">
                    Category:
                    <span class="cart-category-name">${category}</span>
                  </p>
                </li>
                <li class="product-info-item">
                  <p class="cart-product-size">
                    Size: <span class="cart-product-size-value">${size}</span>
                  </p>
                </li>
              </ul>
              <p class="cart-product-price">$${price}</p>
            </div>            
          </li>
            `;
    }).join("");
    else return `
          <div class="cart-empty-product">
            <img
              src="${0, (/*@__PURE__*/$parcel$interopDefault($6RuPt))}"
              alt="empty"
              class="cart-epmpty-img"
            />
            <p class="cart-empty-title">
              Your basket is <span class=cart-empty-accent> empty...</span>
            </p>
            <p class="cart-empty-text">
              Go to the main page to select your favorite products and add them to the cart.
            </p>
          </div>`;
}
function $c0d754f4426227cd$export$cdd53e9d83833acd(products) {
    const markupCardArray = products.map(({ img: img, name: name, category: category, size: size, popularity: popularity, price: price, _id: _id })=>{
        const isInCart = (0, $eayiT.loadFromLocalStorage)((0, $ls5ZR.CART_KEY));
        let paste = "";
        let isAddedProduct = true;
        if (isInCart && isInCart.some((item)=>item._id === _id)) paste = `<svg class="cart_svg" width="18" height="18"><use href="${0, (/*@__PURE__*/$parcel$interopDefault($bGAvv))}#icon-check"></use></svg>`;
        else {
            paste = `<svg class="cart_svg" width="18" height="18"><use href="${0, (/*@__PURE__*/$parcel$interopDefault($bGAvv))}#icon-shopping-cart"></use></svg>`;
            isAddedProduct = false;
        }
        return `
            <li class="card" id="${_id}">
            <div class="bg_img">
              <img src="${img}" class="img_card" alt="${name}" />
            </div>
            <div class="text_wrapped">
              <h2 class="text_name_prod">${name}</h2>
              <div class="wrapper_info">
                <p class="text_title">Category:</p>
                <span class="text_subtitle">${category}</span>
                <p class="text_title">Size:</p>
                <span class="text_subtitle">${size}</span><br/>
                <p class="text_title">Popularity:</p>
                <span class="text_subtitle">${popularity}</span>
              </div>
            </div>
            <div class="wrapper_price">
              <span class="text_price">$${price}</span>
              <button type="button" id="${_id}" aria-label="add-item" data-id="${_id}" data-is-added=${isAddedProduct} class="products-cart-btn js-btn">
                ${paste}
              </button>
            </div>
          </li>
            `;
    });
    return markupCardArray.join("");
}
function $c0d754f4426227cd$export$fc0ff788b21a7621({ img: img, name: name, category: category, size: size, popularity: popularity, price: price, desc: desc, _id: _id }) {
    const isInCart = (0, $eayiT.loadFromLocalStorage)((0, $ls5ZR.CART_KEY));
    let isProductAdded = true;
    let textBtnisProductAdded = "Add to";
    if (isInCart && isInCart.some((item)=>item._id === _id)) textBtnisProductAdded = "Remove from";
    else {
        textBtnisProductAdded = "Add to";
        isProductAdded = false;
    }
    return `
            
              <div class="modal" data-modal-id = "${_id}">
                <button type="button" id="${_id}" aria-label="close-modal" class="modal-close-btn" data-modal-close>
                  <svg class="modal-close-icon">
                    <use href="${0, (/*@__PURE__*/$parcel$interopDefault($bGAvv))}#icon-close"></use>
                  </svg>
                </button>
                <div class="modal-content">
                  <div class="modal-main-row">
                    <div class="modal-image-bg">
                      <img src="${img}" alt="${name}" class="modal-image" />
                    </div>
                    <div class="modal-description-wrapper">
                      <div class="modal-list-wrapper">
                        <h3 class="modal-product-name">${name}</h3>
                        <ul class="modal-list">
                          <li class="modal-list-item">
                            <p>Category: <span class="modal-span">${category}</span></p>
                          </li>
                          <li class="modal-list-item">
                            <p>Size: <span class="modal-span">${size}</span></p>
                          </li>
                          <li class="modal-list-item">
                            <p>Popularity: <span class="modal-span">${popularity}</span></p>
                          </li>
                        </ul>
                      </div>
                      <p class="modal-text">
                        ${desc}
                      </p>
                    </div>
                  </div>
                  <div class="modal-bottom-row">
                    <h3 class="modal-price">$${price}</h3>
                    <button type="button" id="${_id}" aria-label="add-modal" class="modal-btn js-btn" data-is-added=${isProductAdded} data-id="${_id}">
                      ${textBtnisProductAdded}
                     <svg class="cart_svg" width="18" height="18"><use href="${0, (/*@__PURE__*/$parcel$interopDefault($bGAvv))}#icon-shopping-cart"></use></svg>
                    </button>
                  </div>
                </div>
              
            `;
}
function $c0d754f4426227cd$export$d78ba3996ccc9aa(products) {
    const markupPopularProductsArray = products.map(({ img: img, name: name, category: category, size: size, popularity: popularity, _id: _id })=>{
        const isInCart = (0, $eayiT.loadFromLocalStorage)((0, $ls5ZR.CART_KEY));
        let paste = "";
        let isAddToCart = "add-to-basket";
        let isAddedProduct = true;
        if (isInCart && isInCart.some((item)=>item._id === _id)) {
            paste = `<svg class="popular-basket" width="18" height="18"><use href="${0, (/*@__PURE__*/$parcel$interopDefault($bGAvv))}#icon-check"></use></svg>`;
            isAddToCart += " add";
        } else {
            paste = `<svg class="popular-basket" width="18" height="18"><use href="${0, (/*@__PURE__*/$parcel$interopDefault($bGAvv))}#icon-shopping-cart"></use></svg>`;
            isAddedProduct = false;
        }
        return `
            <li class="popular-item" id = "${_id}"><div class="product-card">
            <div class="popular-product-icon"><img src="${img}" alt="${name}"></div>
            
            <div class="product-details">
                <p class="popular-name">${name}</p>
            <p class="popular-text">Category: <span class="popular-span popular-category">${category}</span></p>
            <div class="row">
            <p class="popular-text">Size: <span class="popular-span popular-size">${size}</span></p>
            <p class="popular-text">Popularity: <span class="popular-span popular-size">${popularity}</span></p>
        </div>
            </div>
            <button class="${isAddToCart} js-btn" id="${_id}" aria-label="popular-add-item" data-is-added=${isAddedProduct} data-id="${_id}">${paste}</button>
          </div></li>
            `;
    });
    return markupPopularProductsArray.join("");
}
function $c0d754f4426227cd$export$b8a7adf6f62d18f9(products) {
    const markupDiscountProductsArray = products.map(({ img: img, name: name, _id: _id, price: price })=>{
        const isInCart = (0, $eayiT.loadFromLocalStorage)((0, $ls5ZR.CART_KEY));
        let paste = "";
        let isAddedProduct = true;
        if (isInCart && isInCart.some((item)=>item._id === _id)) paste = `<svg class="cart_svg" width="18" height="18"><use href="${0, (/*@__PURE__*/$parcel$interopDefault($bGAvv))}#icon-check"></use></svg>`;
        else {
            paste = `<svg class="cart_svg" width="18" height="18"><use href="${0, (/*@__PURE__*/$parcel$interopDefault($bGAvv))}#icon-shopping-cart"></use></svg>`;
            isAddedProduct = false;
        }
        return `
            <li class="discount-item" id = "${_id}">
            <div class="discount-image-bg">
              <img src="${img}" alt="${name}" class="discount-image" />
            </div>
            <div class="discount-info">
              <h3 class="discount-name">${name}</h3>
              <div class="discount-price-btn-wrapper">
                <p class="discount-price">${price}</p>
                <button type="button" id="${_id}" aria-label="discount-add-item" class="button discount-btn js-btn" data-is-added=${isAddedProduct} data-id="${_id}">
                  ${paste}
                </button>
              </div>
            </div>
            <img
              src="${0, (/*@__PURE__*/$parcel$interopDefault($dZlgb))}"
              alt="discount sticker"
              class="discount-sticker"
            />
          </li>
            `;
    });
    return markupDiscountProductsArray.join("");
}

});
parcelRegister("bGAvv", function(module, exports) {
module.exports = new URL("icons.7d2de116.svg", import.meta.url).toString();

});

parcelRegister("dZlgb", function(module, exports) {
module.exports = new URL("discount.bf9ea60d.png", import.meta.url).toString();

});

parcelRegister("6RuPt", function(module, exports) {
module.exports = new URL("yellow-shopping-basket.69e8f8e3.png", import.meta.url).toString();

});


var $f43af53dffbf46aa$exports = {};

(parcelRequire("kyEFX")).register(new URL("", import.meta.url).toString(), JSON.parse('["d3pfZ","cart.c01d14ac.js","8OQ7p","icons.7d2de116.svg","77oX9","discount.bf9ea60d.png","jTGmz","yellow-shopping-basket.69e8f8e3.png"]'));

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $3748ebad406aab4f$var$extendStatics = function(d, b) {
    $3748ebad406aab4f$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $3748ebad406aab4f$var$extendStatics(d, b);
};
function $3748ebad406aab4f$export$a8ba968b8961cb8a(d, b) {
    $3748ebad406aab4f$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $3748ebad406aab4f$export$18ce0697a983be9b = function() {
    $3748ebad406aab4f$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3748ebad406aab4f$export$18ce0697a983be9b.apply(this, arguments);
};
function $3748ebad406aab4f$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $3748ebad406aab4f$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $3748ebad406aab4f$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $3748ebad406aab4f$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $3748ebad406aab4f$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $3748ebad406aab4f$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $3748ebad406aab4f$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $3748ebad406aab4f$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $3748ebad406aab4f$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $3748ebad406aab4f$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $3748ebad406aab4f$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($3748ebad406aab4f$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $3748ebad406aab4f$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $3748ebad406aab4f$export$10c90e4f7922046c(v) {
    return this instanceof $3748ebad406aab4f$export$10c90e4f7922046c ? (this.v = v, this) : new $3748ebad406aab4f$export$10c90e4f7922046c(v);
}
function $3748ebad406aab4f$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $3748ebad406aab4f$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $3748ebad406aab4f$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $3748ebad406aab4f$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $3748ebad406aab4f$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $3748ebad406aab4f$export$19a8beecd37a4c45 === "function" ? $3748ebad406aab4f$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $3748ebad406aab4f$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $3748ebad406aab4f$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $3748ebad406aab4f$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $3748ebad406aab4f$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $3748ebad406aab4f$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}





var $57de34230c9ae646$var$eventListenerOptions;
var $57de34230c9ae646$var$eventMap = new WeakMap();
function $57de34230c9ae646$var$getOptions() {
    if ($57de34230c9ae646$var$eventListenerOptions !== undefined) return $57de34230c9ae646$var$eventListenerOptions;
    var supportPassiveEvent = false;
    try {
        var noop = function() {};
        var options = Object.defineProperty({}, "passive", {
            enumerable: true,
            get: function() {
                supportPassiveEvent = true;
                return true;
            }
        });
        window.addEventListener("testPassive", noop, options);
        window.removeEventListener("testPassive", noop, options);
    } catch (e) {}
    $57de34230c9ae646$var$eventListenerOptions = supportPassiveEvent ? {
        passive: false
    } : false;
    return $57de34230c9ae646$var$eventListenerOptions;
}
function $57de34230c9ae646$export$cfedec40817575fe(scrollbar) {
    var configs = $57de34230c9ae646$var$eventMap.get(scrollbar) || [];
    $57de34230c9ae646$var$eventMap.set(scrollbar, configs);
    return function addEvent(elem, events, fn) {
        function handler(event) {
            // ignore default prevented events
            if (event.defaultPrevented) return;
            fn(event);
        }
        events.split(/\s+/g).forEach(function(eventName) {
            configs.push({
                elem: elem,
                eventName: eventName,
                handler: handler
            });
            elem.addEventListener(eventName, handler, $57de34230c9ae646$var$getOptions());
        });
    };
}
function $57de34230c9ae646$export$2bf7a27f443e4893(scrollbar) {
    var configs = $57de34230c9ae646$var$eventMap.get(scrollbar);
    if (!configs) return;
    configs.forEach(function(_a) {
        var elem = _a.elem, eventName = _a.eventName, handler = _a.handler;
        elem.removeEventListener(eventName, handler, $57de34230c9ae646$var$getOptions());
    });
    $57de34230c9ae646$var$eventMap.delete(scrollbar);
}


/**
 * Get pointer/touch data
 */ function $acbecc27f1325a16$export$f7b14ec3e1349d05(evt) {
    // if is touch event, return last item in touchList
    // else return original event
    return evt.touches ? evt.touches[evt.touches.length - 1] : evt;
}



function $d78acfd61a103dcf$export$1690e12b840569b9(evt) {
    var data = (0, $acbecc27f1325a16$export$f7b14ec3e1349d05)(evt);
    return {
        x: data.clientX,
        y: data.clientY
    };
}


/**
 * Check if `a` is one of `[...b]`
 */ function $11887bcec16c296a$export$532a90c0e5e8e48c(a, b) {
    if (b === void 0) b = [];
    return b.some(function(v) {
        return a === v;
    });
}


var $f4b29f7cecbc7dbf$var$VENDOR_PREFIX = [
    "webkit",
    "moz",
    "ms",
    "o"
];
var $f4b29f7cecbc7dbf$var$RE = new RegExp("^-(?!(?:" + $f4b29f7cecbc7dbf$var$VENDOR_PREFIX.join("|") + ")-)");
function $f4b29f7cecbc7dbf$var$autoPrefix(styles) {
    var res = {};
    Object.keys(styles).forEach(function(prop) {
        if (!$f4b29f7cecbc7dbf$var$RE.test(prop)) {
            res[prop] = styles[prop];
            return;
        }
        var val = styles[prop];
        prop = prop.replace(/^-/, "");
        res[prop] = val;
        $f4b29f7cecbc7dbf$var$VENDOR_PREFIX.forEach(function(prefix) {
            res["-" + prefix + "-" + prop] = val;
        });
    });
    return res;
}
function $f4b29f7cecbc7dbf$export$37a5fde709c1db82(elem, styles) {
    styles = $f4b29f7cecbc7dbf$var$autoPrefix(styles);
    Object.keys(styles).forEach(function(prop) {
        var cssProp = prop.replace(/^-/, "").replace(/-([a-z])/g, function(_, $1) {
            return $1.toUpperCase();
        });
        elem.style[cssProp] = styles[prop];
    });
}




var $07f7ea0a915e3f32$export$254d9747e34ddc90 = /** @class */ function() {
    function Tracker(touch) {
        this.velocityMultiplier = window.devicePixelRatio;
        this.updateTime = Date.now();
        this.delta = {
            x: 0,
            y: 0
        };
        this.velocity = {
            x: 0,
            y: 0
        };
        this.lastPosition = {
            x: 0,
            y: 0
        };
        this.lastPosition = (0, $d78acfd61a103dcf$export$1690e12b840569b9)(touch);
    }
    Tracker.prototype.update = function(touch) {
        var _a = this, velocity = _a.velocity, updateTime = _a.updateTime, lastPosition = _a.lastPosition;
        var now = Date.now();
        var position = (0, $d78acfd61a103dcf$export$1690e12b840569b9)(touch);
        var delta = {
            x: -(position.x - lastPosition.x),
            y: -(position.y - lastPosition.y)
        };
        var duration = now - updateTime || 16.7;
        var vx = delta.x / duration * 16.7;
        var vy = delta.y / duration * 16.7;
        velocity.x = vx * this.velocityMultiplier;
        velocity.y = vy * this.velocityMultiplier;
        this.delta = delta;
        this.updateTime = now;
        this.lastPosition = position;
    };
    return Tracker;
}();
var $07f7ea0a915e3f32$export$9da4f16074124683 = /** @class */ function() {
    function TouchRecord() {
        this._touchList = {};
    }
    Object.defineProperty(TouchRecord.prototype, "_primitiveValue", {
        get: function() {
            return {
                x: 0,
                y: 0
            };
        },
        enumerable: true,
        configurable: true
    });
    TouchRecord.prototype.isActive = function() {
        return this._activeTouchID !== undefined;
    };
    TouchRecord.prototype.getDelta = function() {
        var tracker = this._getActiveTracker();
        if (!tracker) return this._primitiveValue;
        return (0, $3748ebad406aab4f$export$18ce0697a983be9b)({}, tracker.delta);
    };
    TouchRecord.prototype.getVelocity = function() {
        var tracker = this._getActiveTracker();
        if (!tracker) return this._primitiveValue;
        return (0, $3748ebad406aab4f$export$18ce0697a983be9b)({}, tracker.velocity);
    };
    TouchRecord.prototype.getEasingDistance = function(damping) {
        var deAcceleration = 1 - damping;
        var distance = {
            x: 0,
            y: 0
        };
        var vel = this.getVelocity();
        Object.keys(vel).forEach(function(dir) {
            // ignore small velocity
            var v = Math.abs(vel[dir]) <= 10 ? 0 : vel[dir];
            while(v !== 0){
                distance[dir] += v;
                v = v * deAcceleration | 0;
            }
        });
        return distance;
    };
    TouchRecord.prototype.track = function(evt) {
        var _this = this;
        var targetTouches = evt.targetTouches;
        Array.from(targetTouches).forEach(function(touch) {
            _this._add(touch);
        });
        return this._touchList;
    };
    TouchRecord.prototype.update = function(evt) {
        var _this = this;
        var touches = evt.touches, changedTouches = evt.changedTouches;
        Array.from(touches).forEach(function(touch) {
            _this._renew(touch);
        });
        this._setActiveID(changedTouches);
        return this._touchList;
    };
    TouchRecord.prototype.release = function(evt) {
        var _this = this;
        delete this._activeTouchID;
        Array.from(evt.changedTouches).forEach(function(touch) {
            _this._delete(touch);
        });
    };
    TouchRecord.prototype._add = function(touch) {
        if (this._has(touch)) // reset tracker
        this._delete(touch);
        var tracker = new $07f7ea0a915e3f32$export$254d9747e34ddc90(touch);
        this._touchList[touch.identifier] = tracker;
    };
    TouchRecord.prototype._renew = function(touch) {
        if (!this._has(touch)) return;
        var tracker = this._touchList[touch.identifier];
        tracker.update(touch);
    };
    TouchRecord.prototype._delete = function(touch) {
        delete this._touchList[touch.identifier];
    };
    TouchRecord.prototype._has = function(touch) {
        return this._touchList.hasOwnProperty(touch.identifier);
    };
    TouchRecord.prototype._setActiveID = function(touches) {
        this._activeTouchID = touches[touches.length - 1].identifier;
    };
    TouchRecord.prototype._getActiveTracker = function() {
        var _a = this, _touchList = _a._touchList, _activeTouchID = _a._activeTouchID;
        return _touchList[_activeTouchID];
    };
    return TouchRecord;
}();


function $599fd5628d0ff009$export$7d15b64cf5a3a4c4(value, lower, upper) {
    return Math.max(lower, Math.min(upper, value));
}


function $f2d4305e8988003d$export$61fc7d43ac8f84b0(fn, wait, leading) {
    if (wait === void 0) wait = 0;
    var timer;
    var lastCalledAt = -Infinity;
    return function debouncedFn() {
        var _this = this;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (leading) {
            var now = Date.now();
            var elapsed = now - lastCalledAt;
            lastCalledAt = now;
            if (elapsed >= wait) fn.apply(this, args);
        }
        clearTimeout(timer);
        timer = setTimeout(function() {
            fn.apply(_this, args);
        }, wait);
    };
}






function $ec613601387ec78b$export$d02631cccf789723(min, max) {
    if (min === void 0) min = -Infinity;
    if (max === void 0) max = Infinity;
    return function(proto, key) {
        var alias = "_" + key;
        Object.defineProperty(proto, key, {
            get: function() {
                return this[alias];
            },
            set: function(val) {
                Object.defineProperty(this, alias, {
                    value: (0, $599fd5628d0ff009$export$7d15b64cf5a3a4c4)(val, min, max),
                    enumerable: false,
                    writable: true,
                    configurable: true
                });
            },
            enumerable: true,
            configurable: true
        });
    };
}


function $40184b623378a49d$export$4a21f16c33752377(proto, key) {
    var alias = "_" + key;
    Object.defineProperty(proto, key, {
        get: function() {
            return this[alias];
        },
        set: function(val) {
            Object.defineProperty(this, alias, {
                value: !!val,
                enumerable: false,
                writable: true,
                configurable: true
            });
        },
        enumerable: true,
        configurable: true
    });
}




function $62b20f35e3bda161$export$61fc7d43ac8f84b0() {
    var options = [];
    for(var _i = 0; _i < arguments.length; _i++)options[_i] = arguments[_i];
    return function(_proto, key, descriptor) {
        var fn = descriptor.value;
        return {
            get: function() {
                if (!this.hasOwnProperty(key)) Object.defineProperty(this, key, {
                    value: (0, $f2d4305e8988003d$export$61fc7d43ac8f84b0).apply(void 0, (0, $3748ebad406aab4f$export$6388937ca91ccae8)([
                        fn
                    ], options))
                });
                return this[key];
            }
        };
    };
}




var $adccde77cb8563a3$export$c019608e5b5bb4cb = /** @class */ function() {
    function Options(config) {
        var _this = this;
        if (config === void 0) config = {};
        /**
         * Momentum reduction damping factor, a float value between `(0, 1)`.
         * The lower the value is, the more smooth the scrolling will be
         * (also the more paint frames).
         */ this.damping = 0.1;
        /**
         * Minimal size for scrollbar thumbs.
         */ this.thumbMinSize = 20;
        /**
         * Render every frame in integer pixel values
         * set to `true` to improve scrolling performance.
         */ this.renderByPixels = true;
        /**
         * Keep scrollbar tracks visible
         */ this.alwaysShowTracks = false;
        /**
         * Set to `true` to allow outer scrollbars continue scrolling
         * when current scrollbar reaches edge.
         */ this.continuousScrolling = true;
        /**
         * Delegate wheel events and touch events to the given element.
         * By default, the container element is used.
         * This option will be useful for dealing with fixed elements.
         */ this.delegateTo = null;
        /**
         * Options for plugins. Syntax:
         *   plugins[pluginName] = pluginOptions: any
         */ this.plugins = {};
        Object.keys(config).forEach(function(prop) {
            _this[prop] = config[prop];
        });
    }
    Object.defineProperty(Options.prototype, "wheelEventTarget", {
        get: function() {
            return this.delegateTo;
        },
        set: function(el) {
            console.warn("[smooth-scrollbar]: `options.wheelEventTarget` is deprecated and will be removed in the future, use `options.delegateTo` instead.");
            this.delegateTo = el;
        },
        enumerable: true,
        configurable: true
    });
    (0, $3748ebad406aab4f$export$29e00dfd3077644b)([
        (0, $ec613601387ec78b$export$d02631cccf789723)(0, 1)
    ], Options.prototype, "damping", void 0);
    (0, $3748ebad406aab4f$export$29e00dfd3077644b)([
        (0, $ec613601387ec78b$export$d02631cccf789723)(0, Infinity)
    ], Options.prototype, "thumbMinSize", void 0);
    (0, $3748ebad406aab4f$export$29e00dfd3077644b)([
        (0, $40184b623378a49d$export$4a21f16c33752377)
    ], Options.prototype, "renderByPixels", void 0);
    (0, $3748ebad406aab4f$export$29e00dfd3077644b)([
        (0, $40184b623378a49d$export$4a21f16c33752377)
    ], Options.prototype, "alwaysShowTracks", void 0);
    (0, $3748ebad406aab4f$export$29e00dfd3077644b)([
        (0, $40184b623378a49d$export$4a21f16c33752377)
    ], Options.prototype, "continuousScrolling", void 0);
    return Options;
}();





var $011cab1e1ae91efd$export$2d4c17c1fb94ad57;
(function(TrackDirection) {
    TrackDirection["X"] = "x";
    TrackDirection["Y"] = "y";
})($011cab1e1ae91efd$export$2d4c17c1fb94ad57 || ($011cab1e1ae91efd$export$2d4c17c1fb94ad57 = {}));



var $f61c3668e0fdeea9$export$2d610e681b8dabf8 = /** @class */ function() {
    function ScrollbarThumb(_direction, _minSize) {
        if (_minSize === void 0) _minSize = 0;
        this._direction = _direction;
        this._minSize = _minSize;
        /**
         * Thumb element
         */ this.element = document.createElement("div");
        /**
         * Display size of the thumb
         * will always be greater than `scrollbar.options.thumbMinSize`
         */ this.displaySize = 0;
        /**
         * Actual size of the thumb
         */ this.realSize = 0;
        /**
         * Thumb offset to the top
         */ this.offset = 0;
        this.element.className = "scrollbar-thumb scrollbar-thumb-" + _direction;
    }
    /**
     * Attach to track element
     *
     * @param trackEl Track element
     */ ScrollbarThumb.prototype.attachTo = function(trackEl) {
        trackEl.appendChild(this.element);
    };
    ScrollbarThumb.prototype.update = function(scrollOffset, containerSize, pageSize) {
        // calculate thumb size
        // pageSize > containerSize -> scrollable
        this.realSize = Math.min(containerSize / pageSize, 1) * containerSize;
        this.displaySize = Math.max(this.realSize, this._minSize);
        // calculate thumb offset
        this.offset = scrollOffset / pageSize * (containerSize + (this.realSize - this.displaySize));
        (0, $f4b29f7cecbc7dbf$export$37a5fde709c1db82)(this.element, this._getStyle());
    };
    ScrollbarThumb.prototype._getStyle = function() {
        switch(this._direction){
            case (0, $011cab1e1ae91efd$export$2d4c17c1fb94ad57).X:
                return {
                    width: this.displaySize + "px",
                    "-transform": "translate3d(" + this.offset + "px, 0, 0)"
                };
            case (0, $011cab1e1ae91efd$export$2d4c17c1fb94ad57).Y:
                return {
                    height: this.displaySize + "px",
                    "-transform": "translate3d(0, " + this.offset + "px, 0)"
                };
            default:
                return null;
        }
    };
    return ScrollbarThumb;
}();



var $51e20527f6106658$export$9e82a9d3e0d2088 = /** @class */ function() {
    function ScrollbarTrack(direction, thumbMinSize) {
        if (thumbMinSize === void 0) thumbMinSize = 0;
        /**
         * Track element
         */ this.element = document.createElement("div");
        this._isShown = false;
        this.element.className = "scrollbar-track scrollbar-track-" + direction;
        this.thumb = new (0, $f61c3668e0fdeea9$export$2d610e681b8dabf8)(direction, thumbMinSize);
        this.thumb.attachTo(this.element);
    }
    /**
     * Attach to scrollbar container element
     *
     * @param scrollbarContainer Scrollbar container element
     */ ScrollbarTrack.prototype.attachTo = function(scrollbarContainer) {
        scrollbarContainer.appendChild(this.element);
    };
    /**
     * Show track immediately
     */ ScrollbarTrack.prototype.show = function() {
        if (this._isShown) return;
        this._isShown = true;
        this.element.classList.add("show");
    };
    /**
     * Hide track immediately
     */ ScrollbarTrack.prototype.hide = function() {
        if (!this._isShown) return;
        this._isShown = false;
        this.element.classList.remove("show");
    };
    ScrollbarTrack.prototype.update = function(scrollOffset, containerSize, pageSize) {
        (0, $f4b29f7cecbc7dbf$export$37a5fde709c1db82)(this.element, {
            display: pageSize <= containerSize ? "none" : "block"
        });
        this.thumb.update(scrollOffset, containerSize, pageSize);
    };
    return ScrollbarTrack;
}();




var $9354e59794b8147e$export$40a0242a5dec07f5 = /** @class */ function() {
    function TrackController(_scrollbar) {
        this._scrollbar = _scrollbar;
        var thumbMinSize = _scrollbar.options.thumbMinSize;
        this.xAxis = new (0, $51e20527f6106658$export$9e82a9d3e0d2088)((0, $011cab1e1ae91efd$export$2d4c17c1fb94ad57).X, thumbMinSize);
        this.yAxis = new (0, $51e20527f6106658$export$9e82a9d3e0d2088)((0, $011cab1e1ae91efd$export$2d4c17c1fb94ad57).Y, thumbMinSize);
        this.xAxis.attachTo(_scrollbar.containerEl);
        this.yAxis.attachTo(_scrollbar.containerEl);
        if (_scrollbar.options.alwaysShowTracks) {
            this.xAxis.show();
            this.yAxis.show();
        }
    }
    /**
     * Updates track appearance
     */ TrackController.prototype.update = function() {
        var _a = this._scrollbar, size = _a.size, offset = _a.offset;
        this.xAxis.update(offset.x, size.container.width, size.content.width);
        this.yAxis.update(offset.y, size.container.height, size.content.height);
    };
    /**
     * Automatically hide tracks when scrollbar is in idle state
     */ TrackController.prototype.autoHideOnIdle = function() {
        if (this._scrollbar.options.alwaysShowTracks) return;
        this.xAxis.hide();
        this.yAxis.hide();
    };
    (0, $3748ebad406aab4f$export$29e00dfd3077644b)([
        (0, $62b20f35e3bda161$export$61fc7d43ac8f84b0)(300)
    ], TrackController.prototype, "autoHideOnIdle", null);
    return TrackController;
}();


function $0dcea7cb1c6b8a4c$export$31b21d0167753bb4(scrollbar) {
    var containerEl = scrollbar.containerEl, contentEl = scrollbar.contentEl;
    var containerStyles = getComputedStyle(containerEl);
    var paddings = [
        "paddingTop",
        "paddingBottom",
        "paddingLeft",
        "paddingRight"
    ].map(function(prop) {
        return containerStyles[prop] ? parseFloat(containerStyles[prop]) : 0;
    });
    var verticalPadding = paddings[0] + paddings[1];
    var horizontalPadding = paddings[2] + paddings[3];
    return {
        container: {
            // requires `overflow: hidden`
            width: containerEl.clientWidth,
            height: containerEl.clientHeight
        },
        content: {
            // border width and paddings should be included
            width: contentEl.offsetWidth - contentEl.clientWidth + contentEl.scrollWidth + horizontalPadding,
            height: contentEl.offsetHeight - contentEl.clientHeight + contentEl.scrollHeight + verticalPadding
        }
    };
}


function $cdc4074216c5d153$export$795910f5f15a9633(scrollbar, elem) {
    var bounding = scrollbar.bounding;
    var targetBounding = elem.getBoundingClientRect();
    // check overlapping
    var top = Math.max(bounding.top, targetBounding.top);
    var left = Math.max(bounding.left, targetBounding.left);
    var right = Math.min(bounding.right, targetBounding.right);
    var bottom = Math.min(bounding.bottom, targetBounding.bottom);
    return top < bottom && left < right;
}


function $4c61def8addee43f$export$722fbec263ad908a(scrollbar) {
    var newSize = scrollbar.getSize();
    var limit = {
        x: Math.max(newSize.content.width - newSize.container.width, 0),
        y: Math.max(newSize.content.height - newSize.container.height, 0)
    };
    // metrics
    var containerBounding = scrollbar.containerEl.getBoundingClientRect();
    var bounding = {
        top: Math.max(containerBounding.top, 0),
        right: Math.min(containerBounding.right, window.innerWidth),
        bottom: Math.min(containerBounding.bottom, window.innerHeight),
        left: Math.max(containerBounding.left, 0)
    };
    // assign props
    scrollbar.size = newSize;
    scrollbar.limit = limit;
    scrollbar.bounding = bounding;
    // update tracks
    scrollbar.track.update();
    // re-positioning
    scrollbar.setPosition();
}







function $756f0affcb52cc5c$export$f9b088a47202d605(scrollbar, x, y) {
    var options = scrollbar.options, offset = scrollbar.offset, limit = scrollbar.limit, track = scrollbar.track, contentEl = scrollbar.contentEl;
    if (options.renderByPixels) {
        x = Math.round(x);
        y = Math.round(y);
    }
    x = (0, $599fd5628d0ff009$export$7d15b64cf5a3a4c4)(x, 0, limit.x);
    y = (0, $599fd5628d0ff009$export$7d15b64cf5a3a4c4)(y, 0, limit.y);
    // position changed -> show track for 300ms
    if (x !== offset.x) track.xAxis.show();
    if (y !== offset.y) track.yAxis.show();
    if (!options.alwaysShowTracks) track.autoHideOnIdle();
    if (x === offset.x && y === offset.y) return null;
    offset.x = x;
    offset.y = y;
    (0, $f4b29f7cecbc7dbf$export$37a5fde709c1db82)(contentEl, {
        "-transform": "translate3d(" + -x + "px, " + -y + "px, 0)"
    });
    track.update();
    return {
        offset: (0, $3748ebad406aab4f$export$18ce0697a983be9b)({}, offset),
        limit: (0, $3748ebad406aab4f$export$18ce0697a983be9b)({}, limit)
    };
}



var $b1c3bed272aa9ff6$var$animationIDStorage = new WeakMap();
function $b1c3bed272aa9ff6$export$3f99968195accfaf(scrollbar, x, y, duration, _a) {
    if (duration === void 0) duration = 0;
    var _b = _a === void 0 ? {} : _a, _c = _b.easing, easing = _c === void 0 ? $b1c3bed272aa9ff6$var$defaultEasing : _c, callback = _b.callback;
    var options = scrollbar.options, offset = scrollbar.offset, limit = scrollbar.limit;
    if (options.renderByPixels) {
        // ensure resolved with integer
        x = Math.round(x);
        y = Math.round(y);
    }
    var startX = offset.x;
    var startY = offset.y;
    var disX = (0, $599fd5628d0ff009$export$7d15b64cf5a3a4c4)(x, 0, limit.x) - startX;
    var disY = (0, $599fd5628d0ff009$export$7d15b64cf5a3a4c4)(y, 0, limit.y) - startY;
    var start = Date.now();
    function scroll() {
        var elapse = Date.now() - start;
        var progress = duration ? easing(Math.min(elapse / duration, 1)) : 1;
        scrollbar.setPosition(startX + disX * progress, startY + disY * progress);
        if (elapse >= duration) {
            if (typeof callback === "function") callback.call(scrollbar);
        } else {
            var animationID = requestAnimationFrame(scroll);
            $b1c3bed272aa9ff6$var$animationIDStorage.set(scrollbar, animationID);
        }
    }
    cancelAnimationFrame($b1c3bed272aa9ff6$var$animationIDStorage.get(scrollbar));
    scroll();
}
/**
 * easeOutCubic
 */ function $b1c3bed272aa9ff6$var$defaultEasing(t) {
    return Math.pow(t - 1, 3) + 1;
}



function $088a190a13ce612b$export$53a0910f038337bd(scrollbar, elem, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.alignToTop, alignToTop = _c === void 0 ? true : _c, _d = _b.onlyScrollIfNeeded, onlyScrollIfNeeded = _d === void 0 ? false : _d, _e = _b.offsetTop, offsetTop = _e === void 0 ? 0 : _e, _f = _b.offsetLeft, offsetLeft = _f === void 0 ? 0 : _f, _g = _b.offsetBottom, offsetBottom = _g === void 0 ? 0 : _g;
    var containerEl = scrollbar.containerEl, bounding = scrollbar.bounding, offset = scrollbar.offset, limit = scrollbar.limit;
    if (!elem || !containerEl.contains(elem)) return;
    var targetBounding = elem.getBoundingClientRect();
    if (onlyScrollIfNeeded && scrollbar.isVisible(elem)) return;
    var delta = alignToTop ? targetBounding.top - bounding.top - offsetTop : targetBounding.bottom - bounding.bottom + offsetBottom;
    scrollbar.setMomentum(targetBounding.left - bounding.left - offsetLeft, (0, $599fd5628d0ff009$export$7d15b64cf5a3a4c4)(delta, -offset.y, limit.y - offset.y));
}





var $c45151114bc28107$export$db53f857c251fca3 = /** @class */ function() {
    function ScrollbarPlugin(scrollbar, options) {
        var _newTarget = this.constructor;
        this.scrollbar = scrollbar;
        this.name = _newTarget.pluginName;
        this.options = (0, $3748ebad406aab4f$export$18ce0697a983be9b)((0, $3748ebad406aab4f$export$18ce0697a983be9b)({}, _newTarget.defaultOptions), options);
    }
    ScrollbarPlugin.prototype.onInit = function() {};
    ScrollbarPlugin.prototype.onDestroy = function() {};
    ScrollbarPlugin.prototype.onUpdate = function() {};
    ScrollbarPlugin.prototype.onRender = function(_remainMomentum) {};
    ScrollbarPlugin.prototype.transformDelta = function(delta, _evt) {
        return (0, $3748ebad406aab4f$export$18ce0697a983be9b)({}, delta);
    };
    ScrollbarPlugin.pluginName = "";
    ScrollbarPlugin.defaultOptions = {};
    return ScrollbarPlugin;
}();
var $c45151114bc28107$export$905153d94e0757fa = {
    order: new Set(),
    constructors: {}
};
function $c45151114bc28107$export$19ec5365ea6ce8cf() {
    var Plugins = [];
    for(var _i = 0; _i < arguments.length; _i++)Plugins[_i] = arguments[_i];
    Plugins.forEach(function(P) {
        var pluginName = P.pluginName;
        if (!pluginName) throw new TypeError("plugin name is required");
        $c45151114bc28107$export$905153d94e0757fa.order.add(pluginName);
        $c45151114bc28107$export$905153d94e0757fa.constructors[pluginName] = P;
    });
}
function $c45151114bc28107$export$d117388934d9aaf6(scrollbar, options) {
    return Array.from($c45151114bc28107$export$905153d94e0757fa.order).filter(function(pluginName) {
        return options[pluginName] !== false;
    }).map(function(pluginName) {
        var Plugin = $c45151114bc28107$export$905153d94e0757fa.constructors[pluginName];
        var instance = new Plugin(scrollbar, options[pluginName]);
        // bind plugin options to `scrollbar.options`
        options[pluginName] = instance.options;
        return instance;
    });
}


var $08244e4761bad9e5$exports = {};
var $ec80c81c6e9d0a33$exports = {};

$parcel$export($ec80c81c6e9d0a33$exports, "keyboardHandler", function () { return $ec80c81c6e9d0a33$export$6ff2ab7955f7f068; });

var $ec80c81c6e9d0a33$var$KEY_CODE;
(function(KEY_CODE) {
    KEY_CODE[KEY_CODE["TAB"] = 9] = "TAB";
    KEY_CODE[KEY_CODE["SPACE"] = 32] = "SPACE";
    KEY_CODE[KEY_CODE["PAGE_UP"] = 33] = "PAGE_UP";
    KEY_CODE[KEY_CODE["PAGE_DOWN"] = 34] = "PAGE_DOWN";
    KEY_CODE[KEY_CODE["END"] = 35] = "END";
    KEY_CODE[KEY_CODE["HOME"] = 36] = "HOME";
    KEY_CODE[KEY_CODE["LEFT"] = 37] = "LEFT";
    KEY_CODE[KEY_CODE["UP"] = 38] = "UP";
    KEY_CODE[KEY_CODE["RIGHT"] = 39] = "RIGHT";
    KEY_CODE[KEY_CODE["DOWN"] = 40] = "DOWN";
})($ec80c81c6e9d0a33$var$KEY_CODE || ($ec80c81c6e9d0a33$var$KEY_CODE = {}));
function $ec80c81c6e9d0a33$export$6ff2ab7955f7f068(scrollbar) {
    var addEvent = (0, $57de34230c9ae646$export$cfedec40817575fe)(scrollbar);
    var container = scrollbar.containerEl;
    addEvent(container, "keydown", function(evt) {
        var activeElement = document.activeElement;
        if (activeElement !== container && !container.contains(activeElement)) return;
        if ($ec80c81c6e9d0a33$var$isEditable(activeElement)) return;
        var delta = $ec80c81c6e9d0a33$var$getKeyDelta(scrollbar, evt.keyCode || evt.which);
        if (!delta) return;
        var x = delta[0], y = delta[1];
        scrollbar.addTransformableMomentum(x, y, evt, function(willScroll) {
            if (willScroll) evt.preventDefault();
            else {
                scrollbar.containerEl.blur();
                if (scrollbar.parent) scrollbar.parent.containerEl.focus();
            }
        });
    });
}
function $ec80c81c6e9d0a33$var$getKeyDelta(scrollbar, keyCode) {
    var size = scrollbar.size, limit = scrollbar.limit, offset = scrollbar.offset;
    switch(keyCode){
        case $ec80c81c6e9d0a33$var$KEY_CODE.TAB:
            return $ec80c81c6e9d0a33$var$handleTabKey(scrollbar);
        case $ec80c81c6e9d0a33$var$KEY_CODE.SPACE:
            return [
                0,
                200
            ];
        case $ec80c81c6e9d0a33$var$KEY_CODE.PAGE_UP:
            return [
                0,
                -size.container.height + 40
            ];
        case $ec80c81c6e9d0a33$var$KEY_CODE.PAGE_DOWN:
            return [
                0,
                size.container.height - 40
            ];
        case $ec80c81c6e9d0a33$var$KEY_CODE.END:
            return [
                0,
                limit.y - offset.y
            ];
        case $ec80c81c6e9d0a33$var$KEY_CODE.HOME:
            return [
                0,
                -offset.y
            ];
        case $ec80c81c6e9d0a33$var$KEY_CODE.LEFT:
            return [
                -40,
                0
            ];
        case $ec80c81c6e9d0a33$var$KEY_CODE.UP:
            return [
                0,
                -40
            ];
        case $ec80c81c6e9d0a33$var$KEY_CODE.RIGHT:
            return [
                40,
                0
            ];
        case $ec80c81c6e9d0a33$var$KEY_CODE.DOWN:
            return [
                0,
                40
            ];
        default:
            return null;
    }
}
function $ec80c81c6e9d0a33$var$handleTabKey(scrollbar) {
    // handle in next frame
    requestAnimationFrame(function() {
        scrollbar.scrollIntoView(document.activeElement, {
            offsetTop: scrollbar.size.container.height / 2,
            offsetLeft: scrollbar.size.container.width / 2,
            onlyScrollIfNeeded: true
        });
    });
}
function $ec80c81c6e9d0a33$var$isEditable(elem) {
    if (elem.tagName === "INPUT" || elem.tagName === "SELECT" || elem.tagName === "TEXTAREA" || elem.isContentEditable) return !elem.disabled;
    return false;
}


var $704b1c9e03a6843d$exports = {};

$parcel$export($704b1c9e03a6843d$exports, "mouseHandler", function () { return $704b1c9e03a6843d$export$242d43875ab79ce3; });


var $704b1c9e03a6843d$var$Direction;
(function(Direction) {
    Direction[Direction["X"] = 0] = "X";
    Direction[Direction["Y"] = 1] = "Y";
})($704b1c9e03a6843d$var$Direction || ($704b1c9e03a6843d$var$Direction = {}));
function $704b1c9e03a6843d$export$242d43875ab79ce3(scrollbar) {
    var addEvent = (0, $57de34230c9ae646$export$cfedec40817575fe)(scrollbar);
    var container = scrollbar.containerEl;
    var _a = scrollbar.track, xAxis = _a.xAxis, yAxis = _a.yAxis;
    function calcMomentum(direction, clickPosition) {
        var size = scrollbar.size, limit = scrollbar.limit, offset = scrollbar.offset;
        if (direction === $704b1c9e03a6843d$var$Direction.X) {
            var totalWidth = size.container.width + (xAxis.thumb.realSize - xAxis.thumb.displaySize);
            return (0, $599fd5628d0ff009$export$7d15b64cf5a3a4c4)(clickPosition / totalWidth * size.content.width, 0, limit.x) - offset.x;
        }
        if (direction === $704b1c9e03a6843d$var$Direction.Y) {
            var totalHeight = size.container.height + (yAxis.thumb.realSize - yAxis.thumb.displaySize);
            return (0, $599fd5628d0ff009$export$7d15b64cf5a3a4c4)(clickPosition / totalHeight * size.content.height, 0, limit.y) - offset.y;
        }
        return 0;
    }
    function getTrackDirection(elem) {
        if ((0, $11887bcec16c296a$export$532a90c0e5e8e48c)(elem, [
            xAxis.element,
            xAxis.thumb.element
        ])) return $704b1c9e03a6843d$var$Direction.X;
        if ((0, $11887bcec16c296a$export$532a90c0e5e8e48c)(elem, [
            yAxis.element,
            yAxis.thumb.element
        ])) return $704b1c9e03a6843d$var$Direction.Y;
        return void 0;
    }
    var isMouseDown;
    var isMouseMoving;
    var startOffsetToThumb;
    var trackDirection;
    var containerRect;
    addEvent(container, "click", function(evt) {
        if (isMouseMoving || !(0, $11887bcec16c296a$export$532a90c0e5e8e48c)(evt.target, [
            xAxis.element,
            yAxis.element
        ])) return;
        var track = evt.target;
        var direction = getTrackDirection(track);
        var rect = track.getBoundingClientRect();
        var clickPos = (0, $d78acfd61a103dcf$export$1690e12b840569b9)(evt);
        if (direction === $704b1c9e03a6843d$var$Direction.X) {
            var offsetOnTrack = clickPos.x - rect.left - xAxis.thumb.displaySize / 2;
            scrollbar.setMomentum(calcMomentum(direction, offsetOnTrack), 0);
        }
        if (direction === $704b1c9e03a6843d$var$Direction.Y) {
            var offsetOnTrack = clickPos.y - rect.top - yAxis.thumb.displaySize / 2;
            scrollbar.setMomentum(0, calcMomentum(direction, offsetOnTrack));
        }
    });
    addEvent(container, "mousedown", function(evt) {
        if (!(0, $11887bcec16c296a$export$532a90c0e5e8e48c)(evt.target, [
            xAxis.thumb.element,
            yAxis.thumb.element
        ])) return;
        isMouseDown = true;
        var thumb = evt.target;
        var cursorPos = (0, $d78acfd61a103dcf$export$1690e12b840569b9)(evt);
        var thumbRect = thumb.getBoundingClientRect();
        trackDirection = getTrackDirection(thumb);
        // pointer offset to thumb
        startOffsetToThumb = {
            x: cursorPos.x - thumbRect.left,
            y: cursorPos.y - thumbRect.top
        };
        // container bounding rectangle
        containerRect = container.getBoundingClientRect();
        // prevent selection, see:
        // https://github.com/idiotWu/smooth-scrollbar/issues/48
        (0, $f4b29f7cecbc7dbf$export$37a5fde709c1db82)(scrollbar.containerEl, {
            "-user-select": "none"
        });
    });
    addEvent(window, "mousemove", function(evt) {
        if (!isMouseDown) return;
        isMouseMoving = true;
        var cursorPos = (0, $d78acfd61a103dcf$export$1690e12b840569b9)(evt);
        if (trackDirection === $704b1c9e03a6843d$var$Direction.X) {
            // get percentage of pointer position in track
            // then tranform to px
            // don't need easing
            var offsetOnTrack = cursorPos.x - startOffsetToThumb.x - containerRect.left;
            scrollbar.setMomentum(calcMomentum(trackDirection, offsetOnTrack), 0);
        }
        if (trackDirection === $704b1c9e03a6843d$var$Direction.Y) {
            var offsetOnTrack = cursorPos.y - startOffsetToThumb.y - containerRect.top;
            scrollbar.setMomentum(0, calcMomentum(trackDirection, offsetOnTrack));
        }
    });
    addEvent(window, "mouseup blur", function() {
        isMouseDown = isMouseMoving = false;
        (0, $f4b29f7cecbc7dbf$export$37a5fde709c1db82)(scrollbar.containerEl, {
            "-user-select": ""
        });
    });
}


var $3839823297e56e76$exports = {};

$parcel$export($3839823297e56e76$exports, "resizeHandler", function () { return $3839823297e56e76$export$53d88fe222065052; });


function $3839823297e56e76$export$53d88fe222065052(scrollbar) {
    var addEvent = (0, $57de34230c9ae646$export$cfedec40817575fe)(scrollbar);
    addEvent(window, "resize", (0, $f2d4305e8988003d$export$61fc7d43ac8f84b0)(scrollbar.update.bind(scrollbar), 300));
}


var $652e1c46628969e6$exports = {};

$parcel$export($652e1c46628969e6$exports, "selectHandler", function () { return $652e1c46628969e6$export$77907cd5c206b555; });


function $652e1c46628969e6$export$77907cd5c206b555(scrollbar) {
    var addEvent = (0, $57de34230c9ae646$export$cfedec40817575fe)(scrollbar);
    var containerEl = scrollbar.containerEl, contentEl = scrollbar.contentEl;
    var isSelected = false;
    var isContextMenuOpened = false; // flag to prevent selection when context menu is opened
    var animationID;
    function scroll(_a) {
        var x = _a.x, y = _a.y;
        if (!x && !y) return;
        var offset = scrollbar.offset, limit = scrollbar.limit;
        // DISALLOW delta transformation
        scrollbar.setMomentum((0, $599fd5628d0ff009$export$7d15b64cf5a3a4c4)(offset.x + x, 0, limit.x) - offset.x, (0, $599fd5628d0ff009$export$7d15b64cf5a3a4c4)(offset.y + y, 0, limit.y) - offset.y);
        animationID = requestAnimationFrame(function() {
            scroll({
                x: x,
                y: y
            });
        });
    }
    addEvent(window, "mousemove", function(evt) {
        if (!isSelected) return;
        cancelAnimationFrame(animationID);
        var dir = $652e1c46628969e6$var$calcMomentum(scrollbar, evt);
        scroll(dir);
    });
    // prevent scrolling when context menu is opened
    // NOTE: `contextmenu` event may be fired
    //          1. BEFORE `selectstart`: when user right-clicks on the text content -> prevent future scrolling,
    //          2. AFTER `selectstart`: when user right-clicks on the blank area -> cancel current scrolling,
    //        so we need to both set the flag and cancel current scrolling
    addEvent(contentEl, "contextmenu", function() {
        // set the flag to prevent future scrolling
        isContextMenuOpened = true;
        // stop current scrolling
        cancelAnimationFrame(animationID);
        isSelected = false;
    });
    // reset context menu flag on mouse down
    // to ensure the scrolling is allowed in the next selection
    addEvent(contentEl, "mousedown", function() {
        isContextMenuOpened = false;
    });
    addEvent(contentEl, "selectstart", function() {
        if (isContextMenuOpened) return;
        cancelAnimationFrame(animationID);
        isSelected = true;
    });
    addEvent(window, "mouseup blur", function() {
        cancelAnimationFrame(animationID);
        isSelected = false;
        isContextMenuOpened = false;
    });
    // patch for touch devices
    addEvent(containerEl, "scroll", function(evt) {
        evt.preventDefault();
        containerEl.scrollTop = containerEl.scrollLeft = 0;
    });
}
function $652e1c46628969e6$var$calcMomentum(scrollbar, evt) {
    var _a = scrollbar.bounding, top = _a.top, right = _a.right, bottom = _a.bottom, left = _a.left;
    var _b = (0, $d78acfd61a103dcf$export$1690e12b840569b9)(evt), x = _b.x, y = _b.y;
    var res = {
        x: 0,
        y: 0
    };
    var padding = 20;
    if (x === 0 && y === 0) return res;
    if (x > right - padding) res.x = x - right + padding;
    else if (x < left + padding) res.x = x - left - padding;
    if (y > bottom - padding) res.y = y - bottom + padding;
    else if (y < top + padding) res.y = y - top - padding;
    res.x *= 2;
    res.y *= 2;
    return res;
}


var $9493b66eb19e3563$exports = {};

$parcel$export($9493b66eb19e3563$exports, "touchHandler", function () { return $9493b66eb19e3563$export$2916e5349c3e671c; });

var $9493b66eb19e3563$var$activeScrollbar;
function $9493b66eb19e3563$export$2916e5349c3e671c(scrollbar) {
    var target = scrollbar.options.delegateTo || scrollbar.containerEl;
    var touchRecord = new (0, $07f7ea0a915e3f32$export$9da4f16074124683)();
    var addEvent = (0, $57de34230c9ae646$export$cfedec40817575fe)(scrollbar);
    var damping;
    var pointerCount = 0;
    addEvent(target, "touchstart", function(evt) {
        // start records
        touchRecord.track(evt);
        // stop scrolling
        scrollbar.setMomentum(0, 0);
        // save damping
        if (pointerCount === 0) {
            damping = scrollbar.options.damping;
            scrollbar.options.damping = Math.max(damping, 0.5); // less frames on touchmove
        }
        pointerCount++;
    });
    addEvent(target, "touchmove", function(evt) {
        if ($9493b66eb19e3563$var$activeScrollbar && $9493b66eb19e3563$var$activeScrollbar !== scrollbar) return;
        touchRecord.update(evt);
        var _a = touchRecord.getDelta(), x = _a.x, y = _a.y;
        scrollbar.addTransformableMomentum(x, y, evt, function(willScroll) {
            if (willScroll && evt.cancelable) {
                evt.preventDefault();
                $9493b66eb19e3563$var$activeScrollbar = scrollbar;
            }
        });
    });
    addEvent(target, "touchcancel touchend", function(evt) {
        var delta = touchRecord.getEasingDistance(damping);
        scrollbar.addTransformableMomentum(delta.x, delta.y, evt);
        pointerCount--;
        // restore damping
        if (pointerCount === 0) scrollbar.options.damping = damping;
        touchRecord.release(evt);
        $9493b66eb19e3563$var$activeScrollbar = null;
    });
}


var $5d97cedb3d92292c$exports = {};

$parcel$export($5d97cedb3d92292c$exports, "wheelHandler", function () { return $5d97cedb3d92292c$export$14c83f6c8045ea84; });

function $5d97cedb3d92292c$export$14c83f6c8045ea84(scrollbar) {
    var addEvent = (0, $57de34230c9ae646$export$cfedec40817575fe)(scrollbar);
    var target = scrollbar.options.delegateTo || scrollbar.containerEl;
    var eventName = "onwheel" in window || document.implementation.hasFeature("Events.wheel", "3.0") ? "wheel" : "mousewheel";
    addEvent(target, eventName, function(evt) {
        var _a = $5d97cedb3d92292c$var$normalizeDelta(evt), x = _a.x, y = _a.y;
        scrollbar.addTransformableMomentum(x, y, evt, function(willScroll) {
            if (willScroll) evt.preventDefault();
        });
    });
}
// Normalizing wheel delta
var $5d97cedb3d92292c$var$DELTA_SCALE = {
    STANDARD: 1,
    OTHERS: -3
};
var $5d97cedb3d92292c$var$DELTA_MODE = [
    1.0,
    28.0,
    500.0
];
var $5d97cedb3d92292c$var$getDeltaMode = function(mode) {
    return $5d97cedb3d92292c$var$DELTA_MODE[mode] || $5d97cedb3d92292c$var$DELTA_MODE[0];
};
function $5d97cedb3d92292c$var$normalizeDelta(evt) {
    if ("deltaX" in evt) {
        var mode = $5d97cedb3d92292c$var$getDeltaMode(evt.deltaMode);
        return {
            x: evt.deltaX / $5d97cedb3d92292c$var$DELTA_SCALE.STANDARD * mode,
            y: evt.deltaY / $5d97cedb3d92292c$var$DELTA_SCALE.STANDARD * mode
        };
    }
    if ("wheelDeltaX" in evt) return {
        x: evt.wheelDeltaX / $5d97cedb3d92292c$var$DELTA_SCALE.OTHERS,
        y: evt.wheelDeltaY / $5d97cedb3d92292c$var$DELTA_SCALE.OTHERS
    };
    // ie with touchpad
    return {
        x: 0,
        y: evt.wheelDelta / $5d97cedb3d92292c$var$DELTA_SCALE.OTHERS
    };
}


$parcel$exportWildcard($08244e4761bad9e5$exports, $ec80c81c6e9d0a33$exports);
$parcel$exportWildcard($08244e4761bad9e5$exports, $704b1c9e03a6843d$exports);
$parcel$exportWildcard($08244e4761bad9e5$exports, $3839823297e56e76$exports);
$parcel$exportWildcard($08244e4761bad9e5$exports, $652e1c46628969e6$exports);
$parcel$exportWildcard($08244e4761bad9e5$exports, $9493b66eb19e3563$exports);
$parcel$exportWildcard($08244e4761bad9e5$exports, $5d97cedb3d92292c$exports);


var $faf9468d6e45cb3e$export$18a24ca5e48929da = new Map();
var $faf9468d6e45cb3e$export$9a4e88b92edfce6b = /** @class */ function() {
    function Scrollbar(containerEl, options) {
        var _this = this;
        /**
         * Current scrolling offsets
         */ this.offset = {
            x: 0,
            y: 0
        };
        /**
         * Max-allowed scrolling offsets
         */ this.limit = {
            x: Infinity,
            y: Infinity
        };
        /**
         * Container bounding rect
         */ this.bounding = {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        };
        // private _observer: ResizeObserver;
        this._plugins = [];
        this._momentum = {
            x: 0,
            y: 0
        };
        this._listeners = new Set();
        this.containerEl = containerEl;
        var contentEl = this.contentEl = document.createElement("div");
        this.options = new (0, $adccde77cb8563a3$export$c019608e5b5bb4cb)(options);
        // mark as a scroll element
        containerEl.setAttribute("data-scrollbar", "true");
        // make container focusable
        containerEl.setAttribute("tabindex", "-1");
        (0, $f4b29f7cecbc7dbf$export$37a5fde709c1db82)(containerEl, {
            overflow: "hidden",
            outline: "none"
        });
        // enable touch event capturing in IE, see:
        // https://github.com/idiotWu/smooth-scrollbar/issues/39
        if (window.navigator.msPointerEnabled) containerEl.style.msTouchAction = "none";
        // mount content
        contentEl.className = "scroll-content";
        Array.from(containerEl.childNodes).forEach(function(node) {
            contentEl.appendChild(node);
        });
        containerEl.appendChild(contentEl);
        // attach track
        this.track = new (0, $9354e59794b8147e$export$40a0242a5dec07f5)(this);
        // initial measuring
        this.size = this.getSize();
        // init plugins
        this._plugins = (0, $c45151114bc28107$export$d117388934d9aaf6)(this, this.options.plugins);
        // preserve scroll offset
        var scrollLeft = containerEl.scrollLeft, scrollTop = containerEl.scrollTop;
        containerEl.scrollLeft = containerEl.scrollTop = 0;
        this.setPosition(scrollLeft, scrollTop, {
            withoutCallbacks: true
        });
        // FIXME: update typescript
        var ResizeObserver = window.ResizeObserver;
        // observe
        if (typeof ResizeObserver === "function") {
            this._observer = new ResizeObserver(function() {
                _this.update();
            });
            this._observer.observe(contentEl);
        }
        $faf9468d6e45cb3e$export$18a24ca5e48929da.set(containerEl, this);
        // wait for DOM ready
        requestAnimationFrame(function() {
            _this._init();
        });
    }
    Object.defineProperty(Scrollbar.prototype, "parent", {
        /**
         * Parent scrollbar
         */ get: function() {
            var elem = this.containerEl.parentElement;
            while(elem){
                var parentScrollbar = $faf9468d6e45cb3e$export$18a24ca5e48929da.get(elem);
                if (parentScrollbar) return parentScrollbar;
                elem = elem.parentElement;
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scrollbar.prototype, "scrollTop", {
        /**
         * Gets or sets `scrollbar.offset.y`
         */ get: function() {
            return this.offset.y;
        },
        set: function(y) {
            this.setPosition(this.scrollLeft, y);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scrollbar.prototype, "scrollLeft", {
        /**
         * Gets or sets `scrollbar.offset.x`
         */ get: function() {
            return this.offset.x;
        },
        set: function(x) {
            this.setPosition(x, this.scrollTop);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns the size of the scrollbar container element
     * and the content wrapper element
     */ Scrollbar.prototype.getSize = function() {
        return (0, $0dcea7cb1c6b8a4c$export$31b21d0167753bb4)(this);
    };
    /**
     * Forces scrollbar to update geometry infomation.
     *
     * By default, scrollbars are automatically updated with `100ms` debounce (or `MutationObserver` fires).
     * You can call this method to force an update when you modified contents
     */ Scrollbar.prototype.update = function() {
        (0, $4c61def8addee43f$export$722fbec263ad908a)(this);
        this._plugins.forEach(function(plugin) {
            plugin.onUpdate();
        });
    };
    /**
     * Checks if an element is visible in the current view area
     */ Scrollbar.prototype.isVisible = function(elem) {
        return (0, $cdc4074216c5d153$export$795910f5f15a9633)(this, elem);
    };
    /**
     * Sets the scrollbar to the given offset without easing
     */ Scrollbar.prototype.setPosition = function(x, y, options) {
        var _this = this;
        if (x === void 0) x = this.offset.x;
        if (y === void 0) y = this.offset.y;
        if (options === void 0) options = {};
        var status = (0, $756f0affcb52cc5c$export$f9b088a47202d605)(this, x, y);
        if (!status || options.withoutCallbacks) return;
        this._listeners.forEach(function(fn) {
            fn.call(_this, status);
        });
    };
    /**
     * Scrolls to given position with easing function
     */ Scrollbar.prototype.scrollTo = function(x, y, duration, options) {
        if (x === void 0) x = this.offset.x;
        if (y === void 0) y = this.offset.y;
        if (duration === void 0) duration = 0;
        if (options === void 0) options = {};
        (0, $b1c3bed272aa9ff6$export$3f99968195accfaf)(this, x, y, duration, options);
    };
    /**
     * Scrolls the target element into visible area of scrollbar,
     * likes the DOM method `element.scrollIntoView().
     */ Scrollbar.prototype.scrollIntoView = function(elem, options) {
        if (options === void 0) options = {};
        (0, $088a190a13ce612b$export$53a0910f038337bd)(this, elem, options);
    };
    /**
     * Adds scrolling listener
     */ Scrollbar.prototype.addListener = function(fn) {
        if (typeof fn !== "function") throw new TypeError("[smooth-scrollbar] scrolling listener should be a function");
        this._listeners.add(fn);
    };
    /**
     * Removes listener previously registered with `scrollbar.addListener()`
     */ Scrollbar.prototype.removeListener = function(fn) {
        this._listeners.delete(fn);
    };
    /**
     * Adds momentum and applys delta transformers.
     */ Scrollbar.prototype.addTransformableMomentum = function(x, y, fromEvent, callback) {
        this._updateDebounced();
        var finalDelta = this._plugins.reduce(function(delta, plugin) {
            return plugin.transformDelta(delta, fromEvent) || delta;
        }, {
            x: x,
            y: y
        });
        var willScroll = !this._shouldPropagateMomentum(finalDelta.x, finalDelta.y);
        if (willScroll) this.addMomentum(finalDelta.x, finalDelta.y);
        if (callback) callback.call(this, willScroll);
    };
    /**
     * Increases scrollbar's momentum
     */ Scrollbar.prototype.addMomentum = function(x, y) {
        this.setMomentum(this._momentum.x + x, this._momentum.y + y);
    };
    /**
     * Sets scrollbar's momentum to given value
     */ Scrollbar.prototype.setMomentum = function(x, y) {
        if (this.limit.x === 0) x = 0;
        if (this.limit.y === 0) y = 0;
        if (this.options.renderByPixels) {
            x = Math.round(x);
            y = Math.round(y);
        }
        this._momentum.x = x;
        this._momentum.y = y;
    };
    /**
     * Update options for specific plugin
     *
     * @param pluginName Name of the plugin
     * @param [options] An object includes the properties that you want to update
     */ Scrollbar.prototype.updatePluginOptions = function(pluginName, options) {
        this._plugins.forEach(function(plugin) {
            if (plugin.name === pluginName) Object.assign(plugin.options, options);
        });
    };
    Scrollbar.prototype.destroy = function() {
        var _a = this, containerEl = _a.containerEl, contentEl = _a.contentEl;
        (0, $57de34230c9ae646$export$2bf7a27f443e4893)(this);
        this._listeners.clear();
        this.setMomentum(0, 0);
        cancelAnimationFrame(this._renderID);
        if (this._observer) this._observer.disconnect();
        $faf9468d6e45cb3e$export$18a24ca5e48929da.delete(this.containerEl);
        // restore contents
        var childNodes = Array.from(contentEl.childNodes);
        while(containerEl.firstChild)containerEl.removeChild(containerEl.firstChild);
        childNodes.forEach(function(el) {
            containerEl.appendChild(el);
        });
        // reset scroll position
        (0, $f4b29f7cecbc7dbf$export$37a5fde709c1db82)(containerEl, {
            overflow: ""
        });
        containerEl.scrollTop = this.scrollTop;
        containerEl.scrollLeft = this.scrollLeft;
        // invoke plugin.onDestroy
        this._plugins.forEach(function(plugin) {
            plugin.onDestroy();
        });
        this._plugins.length = 0;
    };
    Scrollbar.prototype._init = function() {
        var _this = this;
        this.update();
        // init evet handlers
        Object.keys($08244e4761bad9e5$exports).forEach(function(prop) {
            $08244e4761bad9e5$exports[prop](_this);
        });
        // invoke `plugin.onInit`
        this._plugins.forEach(function(plugin) {
            plugin.onInit();
        });
        this._render();
    };
    Scrollbar.prototype._updateDebounced = function() {
        this.update();
    };
    // check whether to propagate monmentum to parent scrollbar
    // the following situations are considered as `true`:
    //         1. continuous scrolling is enabled (automatically disabled when overscroll is enabled)
    //         2. scrollbar reaches one side and is not about to scroll on the other direction
    Scrollbar.prototype._shouldPropagateMomentum = function(deltaX, deltaY) {
        if (deltaX === void 0) deltaX = 0;
        if (deltaY === void 0) deltaY = 0;
        var _a = this, options = _a.options, offset = _a.offset, limit = _a.limit;
        if (!options.continuousScrolling) return false;
        // force an update when scrollbar is "unscrollable", see #106
        if (limit.x === 0 && limit.y === 0) this._updateDebounced();
        var destX = (0, $599fd5628d0ff009$export$7d15b64cf5a3a4c4)(deltaX + offset.x, 0, limit.x);
        var destY = (0, $599fd5628d0ff009$export$7d15b64cf5a3a4c4)(deltaY + offset.y, 0, limit.y);
        var res = true;
        // offsets are not about to change
        // `&=` operator is not allowed for boolean types
        res = res && destX === offset.x;
        res = res && destY === offset.y;
        // current offsets are on the edge
        res = res && (offset.x === limit.x || offset.x === 0 || offset.y === limit.y || offset.y === 0);
        return res;
    };
    Scrollbar.prototype._render = function() {
        var _momentum = this._momentum;
        if (_momentum.x || _momentum.y) {
            var nextX = this._nextTick("x");
            var nextY = this._nextTick("y");
            _momentum.x = nextX.momentum;
            _momentum.y = nextY.momentum;
            this.setPosition(nextX.position, nextY.position);
        }
        var remain = (0, $3748ebad406aab4f$export$18ce0697a983be9b)({}, this._momentum);
        this._plugins.forEach(function(plugin) {
            plugin.onRender(remain);
        });
        this._renderID = requestAnimationFrame(this._render.bind(this));
    };
    Scrollbar.prototype._nextTick = function(direction) {
        var _a = this, options = _a.options, offset = _a.offset, _momentum = _a._momentum;
        var current = offset[direction];
        var remain = _momentum[direction];
        if (Math.abs(remain) <= 0.1) return {
            momentum: 0,
            position: current + remain
        };
        var nextMomentum = remain * (1 - options.damping);
        if (options.renderByPixels) nextMomentum |= 0;
        return {
            momentum: nextMomentum,
            position: current + remain - nextMomentum
        };
    };
    (0, $3748ebad406aab4f$export$29e00dfd3077644b)([
        (0, $62b20f35e3bda161$export$61fc7d43ac8f84b0)(100, true)
    ], Scrollbar.prototype, "_updateDebounced", null);
    return Scrollbar;
}();



var $463f3869ac82ccec$var$TRACK_BG = "rgba(222, 222, 222, .75)";
var $463f3869ac82ccec$var$THUMB_BG = "rgba(0, 0, 0, .5)";
// sets content's display type to `flow-root` to suppress margin collapsing
var $463f3869ac82ccec$var$SCROLLBAR_STYLE = "\n[data-scrollbar] {\n  display: block;\n  position: relative;\n}\n\n.scroll-content {\n  display: flow-root;\n  -webkit-transform: translate3d(0, 0, 0);\n          transform: translate3d(0, 0, 0);\n}\n\n.scrollbar-track {\n  position: absolute;\n  opacity: 0;\n  z-index: 1;\n  background: " + $463f3869ac82ccec$var$TRACK_BG + ";\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  -webkit-transition: opacity 0.5s 0.5s ease-out;\n          transition: opacity 0.5s 0.5s ease-out;\n}\n.scrollbar-track.show,\n.scrollbar-track:hover {\n  opacity: 1;\n  -webkit-transition-delay: 0s;\n          transition-delay: 0s;\n}\n\n.scrollbar-track-x {\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 8px;\n}\n.scrollbar-track-y {\n  top: 0;\n  right: 0;\n  width: 8px;\n  height: 100%;\n}\n.scrollbar-thumb {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 8px;\n  height: 8px;\n  background: " + $463f3869ac82ccec$var$THUMB_BG + ";\n  border-radius: 4px;\n}\n";
var $463f3869ac82ccec$var$STYLE_ID = "smooth-scrollbar-style";
var $463f3869ac82ccec$var$isStyleAttached = false;
function $463f3869ac82ccec$export$ff76c51b0f744e0a() {
    if ($463f3869ac82ccec$var$isStyleAttached || typeof window === "undefined") return;
    var styleEl = document.createElement("style");
    styleEl.id = $463f3869ac82ccec$var$STYLE_ID;
    styleEl.textContent = $463f3869ac82ccec$var$SCROLLBAR_STYLE;
    if (document.head) document.head.appendChild(styleEl);
    $463f3869ac82ccec$var$isStyleAttached = true;
}
function $463f3869ac82ccec$export$11939e4e3dfbbb72() {
    if (!$463f3869ac82ccec$var$isStyleAttached || typeof window === "undefined") return;
    var styleEl = document.getElementById($463f3869ac82ccec$var$STYLE_ID);
    if (!styleEl || !styleEl.parentNode) return;
    styleEl.parentNode.removeChild(styleEl);
    $463f3869ac82ccec$var$isStyleAttached = false;
}


/**
 * cast `I.Scrollbar` to `Scrollbar` to avoid error
 *
 * `I.Scrollbar` is not assignable to `Scrollbar`:
 *     "privateProp" is missing in `I.Scrollbar`
 *
 * @see https://github.com/Microsoft/TypeScript/issues/2672
 */ var $8ea610dccc5d7c0a$var$SmoothScrollbar = /** @class */ function(_super) {
    (0, $3748ebad406aab4f$export$a8ba968b8961cb8a)(SmoothScrollbar, _super);
    function SmoothScrollbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Initializes a scrollbar on the given element.
     *
     * @param elem The DOM element that you want to initialize scrollbar to
     * @param [options] Initial options
     */ SmoothScrollbar.init = function(elem, options) {
        if (!elem || elem.nodeType !== 1) throw new TypeError("expect element to be DOM Element, but got " + elem);
        // attach stylesheet
        (0, $463f3869ac82ccec$export$ff76c51b0f744e0a)();
        if ((0, $faf9468d6e45cb3e$export$18a24ca5e48929da).has(elem)) return (0, $faf9468d6e45cb3e$export$18a24ca5e48929da).get(elem);
        return new (0, $faf9468d6e45cb3e$export$9a4e88b92edfce6b)(elem, options);
    };
    /**
     * Automatically init scrollbar on all elements base on the selector `[data-scrollbar]`
     *
     * @param options Initial options
     */ SmoothScrollbar.initAll = function(options) {
        return Array.from(document.querySelectorAll("[data-scrollbar]"), function(elem) {
            return SmoothScrollbar.init(elem, options);
        });
    };
    /**
     * Check if there is a scrollbar on given element
     *
     * @param elem The DOM element that you want to check
     */ SmoothScrollbar.has = function(elem) {
        return (0, $faf9468d6e45cb3e$export$18a24ca5e48929da).has(elem);
    };
    /**
     * Gets scrollbar on the given element.
     * If no scrollbar instance exsits, returns `undefined`
     *
     * @param elem The DOM element that you want to check.
     */ SmoothScrollbar.get = function(elem) {
        return (0, $faf9468d6e45cb3e$export$18a24ca5e48929da).get(elem);
    };
    /**
     * Returns an array that contains all scrollbar instances
     */ SmoothScrollbar.getAll = function() {
        return Array.from((0, $faf9468d6e45cb3e$export$18a24ca5e48929da).values());
    };
    /**
     * Removes scrollbar on the given element
     */ SmoothScrollbar.destroy = function(elem) {
        var scrollbar = (0, $faf9468d6e45cb3e$export$18a24ca5e48929da).get(elem);
        if (scrollbar) scrollbar.destroy();
    };
    /**
     * Removes all scrollbar instances from current document
     */ SmoothScrollbar.destroyAll = function() {
        (0, $faf9468d6e45cb3e$export$18a24ca5e48929da).forEach(function(scrollbar) {
            scrollbar.destroy();
        });
    };
    /**
     * Attaches plugins to scrollbars
     *
     * @param ...Plugins Scrollbar plugin classes
     */ SmoothScrollbar.use = function() {
        var Plugins = [];
        for(var _i = 0; _i < arguments.length; _i++)Plugins[_i] = arguments[_i];
        return (0, $c45151114bc28107$export$19ec5365ea6ce8cf).apply(void 0, Plugins);
    };
    /**
     * Attaches default style sheets to current document.
     * You don't need to call this method manually unless
     * you removed the default styles via `Scrollbar.detachStyle()`
     */ SmoothScrollbar.attachStyle = function() {
        return (0, $463f3869ac82ccec$export$ff76c51b0f744e0a)();
    };
    /**
     * Removes default styles from current document.
     * Use this method when you want to use your own css for scrollbars.
     */ SmoothScrollbar.detachStyle = function() {
        return (0, $463f3869ac82ccec$export$11939e4e3dfbbb72)();
    };
    SmoothScrollbar.version = "8.8.4";
    SmoothScrollbar.ScrollbarPlugin = (0, $c45151114bc28107$export$db53f857c251fca3);
    return SmoothScrollbar;
}((0, $faf9468d6e45cb3e$export$9a4e88b92edfce6b));
var $8ea610dccc5d7c0a$export$2e2bcd8739ae039 = $8ea610dccc5d7c0a$var$SmoothScrollbar;



var $bUb57 = parcelRequire("bUb57");

var $eayiT = parcelRequire("eayiT");

var $ls5ZR = parcelRequire("ls5ZR");

var $gyujb = parcelRequire("gyujb");
const $915de8ffc4dd3149$var$productsList = document.querySelector(".products-list");
// saveToLocalStorage(CART_KEY, data);
const $915de8ffc4dd3149$var$btnDeleteAll = document.querySelector(".delete-btn-all");
const $915de8ffc4dd3149$var$tatalPriceProduct = document.querySelector(".sum-total-product");
const $915de8ffc4dd3149$var$amountProduct = document.querySelector(".amount-product-in-cart");
const $915de8ffc4dd3149$var$productsCardContainer = document.querySelector(".product-cart");
$915de8ffc4dd3149$var$btnDeleteAll.addEventListener("click", $915de8ffc4dd3149$var$onClickDeleteAll);
function $915de8ffc4dd3149$var$renderProductInCart() {
    const arrProducts = (0, $eayiT.loadFromLocalStorage)((0, $ls5ZR.CART_KEY)) ?? [];
    if (arrProducts.length === 0) {
        $915de8ffc4dd3149$var$productsCardContainer.innerHTML = (0, $gyujb.createCartMarkup)(arrProducts);
        return;
    }
    const markupCart = (0, $gyujb.createCartMarkup)(arrProducts);
    $915de8ffc4dd3149$var$productsList.innerHTML = markupCart;
    $915de8ffc4dd3149$var$productsList.addEventListener("click", $915de8ffc4dd3149$var$onClickDeleteProduct);
}
function $915de8ffc4dd3149$var$renderTotalPrice() {
    const arrProducts = (0, $eayiT.loadFromLocalStorage)((0, $ls5ZR.CART_KEY)) ?? [];
    const total = $915de8ffc4dd3149$var$totalPrice(arrProducts);
    $915de8ffc4dd3149$var$tatalPriceProduct.innerHTML = total;
}
function $915de8ffc4dd3149$var$chengeAmountProduct() {
    const count = (0, $eayiT.loadFromLocalStorage)((0, $ls5ZR.CART_KEY)) ?? [];
    $915de8ffc4dd3149$var$amountProduct.innerHTML = count.length;
}
function $915de8ffc4dd3149$var$totalPrice(products) {
    if (!products) return 0;
    return products.reduce((acc, product)=>{
        return acc += product.price;
    }, 0).toFixed(2);
}
function $915de8ffc4dd3149$var$updateData() {
    $915de8ffc4dd3149$var$renderTotalPrice();
    (0, $bUb57.amountProductsInCart)();
    $915de8ffc4dd3149$var$chengeAmountProduct();
}
function $915de8ffc4dd3149$var$onClickDeleteAll(event) {
    (0, $eayiT.removeFromLocalStorage)((0, $ls5ZR.CART_KEY));
    $915de8ffc4dd3149$var$updateData();
    $915de8ffc4dd3149$var$renderProductInCart();
}
function $915de8ffc4dd3149$var$onClickDeleteProduct(event) {
    if (!event.target.closest(".cart-delete-btn")) return;
    const idProduct = event.target.closest("button").dataset.id;
    const findProduct = (0, $eayiT.loadFromLocalStorage)((0, $ls5ZR.CART_KEY)).filter(({ _id: _id })=>_id !== idProduct);
    console.log("findProduct: ", findProduct);
    (0, $eayiT.saveToLocalStorage)((0, $ls5ZR.CART_KEY), findProduct);
    if (findProduct.length === 0) {
        $915de8ffc4dd3149$var$updateData();
        $915de8ffc4dd3149$var$renderProductInCart();
    }
    event.target.closest("li").remove();
    $915de8ffc4dd3149$var$updateData();
}
$915de8ffc4dd3149$var$renderProductInCart();
$915de8ffc4dd3149$var$updateData();
const $915de8ffc4dd3149$var$scrollbar = new (0, $8ea610dccc5d7c0a$export$2e2bcd8739ae039).init(document.querySelector("#my-scrollbar"));


//# sourceMappingURL=cart.c01d14ac.js.map
